// skipcq: JS-W1028
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

/**
 * Brewery-admin-only portal routes (dashboard, pint portfolio, etc.).
 * Claim and status routes stay open to any verified brewer.
 */
export default function BreweryAdminPortalRoute({ children }) {
  const user = useContext(UserContext);

  if (user.isBreweryAdmin !== true) {
    return <Navigate to="/brewery-portal/claim" replace />;
  }

  return children;
}
